import React from "react";
import { FleetrifyModal } from "../../../Modal/modal";
import { FleetrifyButton } from "../../../Button/customButton";

export type StaffBulkUploadRow = {
    firstName: string;
    lastName: string;
    role: string;
    branch: string;
    email: string;
    phoneNumber: string;
    resumption: string;
    gender: string;
};

interface StaffPreviewModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (open: boolean) => void;
    isLoading: boolean;
    onSubmit: () => void;
    disabled?: boolean;
    rows: StaffBulkUploadRow[];
}

const StaffPreviewModal: React.FC<StaffPreviewModalProps> = ({
    isModalOpen,
    setIsModalOpen,
    isLoading,
    onSubmit,
    disabled,
    rows,
}) => {
    return (
        <FleetrifyModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            title="Preview Staff Upload"
            className="max-w-4xl h-fit"
        >
            <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-200 rounded-lg">
                    <thead className="bg-gray-100 text-sm text-left text-gray-600">
                        <tr>
                            <th className="p-3 border">First Name</th>
                            <th className="p-3 border">Last Name</th>
                            <th className="p-3 border">Role</th>
                            <th className="p-3 border">Branch</th>
                            <th className="p-3 border">Email</th>
                            <th className="p-3 border">Phone Number</th>
                            <th className="p-3 border">Resumption</th>
                            <th className="p-3 border">Gender</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm">
                        {rows.length > 0 ? (
                            rows.map((row, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="p-2 border">{row.firstName}</td>
                                    <td className="p-2 border">{row.lastName}</td>
                                    <td className="p-2 border">{row.role}</td>
                                    <td className="p-2 border">{row.branch}</td>
                                    <td className="p-2 border">{row.email}</td>
                                    <td className="p-2 border">{row.phoneNumber}</td>
                                    <td className="p-2 border">{row.resumption}</td>
                                    <td className="p-2 border">{row.gender}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={7} className="text-center p-4 text-gray-400">
                                    No staff data to preview
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* actions */}
            <div className="flex justify-end gap-3 mt-6 p-6 ">
                <FleetrifyButton
                    type="button"
                    className="border bg-transparent border-[#143887] text-[#143887] hover:bg-gray-100"
                    onClick={() => setIsModalOpen(false)}
                >
                    Cancel
                </FleetrifyButton>
                <FleetrifyButton
                    loading={isLoading}
                    disabled={disabled || rows.length === 0}
                    onClick={onSubmit}
                >
                    Submit Upload
                </FleetrifyButton>
            </div>
        </FleetrifyModal>
    );
};

export default StaffPreviewModal;
